import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Constants, SessionStorageService } from '../_services';

@Component({
  selector: 'app-footer-dash',
  template: `
<footer class="container-fluid bg-dark p-4 text-white small">
  <div class="row">
    <ul class="nav w-100 flex-sm-nowrap justify-content-center justify-content-sm-end text-center">
      <li *ngFor="let link of linkList" class="nav-item p-2 col-12 col-sm-auto">
        <a class="text-white" [routerLink]="[ link.href ]">{{ link.label }}</a>
      </li>

      <li class="nav-item p-2 col-12 col-sm-auto" *ngIf="isMediaExtraSmall">
        <a class="text-white" href="#" (click)="toggleLanguage($event)">{{ altLanguageLabel }}</a>
      </li>
    </ul>
  </div>
</footer>
`
})
export class FooterDashComponent implements OnInit {
  @Input()
  PrivacyPolicyLabel: string;
  @Input()
  TermsAndConditionsLabel: string;
  @Input()
  FaqLabel: string;
  @Input()
  ContactUsLabel: string;
  @Input()
  EnglishLanguageLabel: string;
  @Input()
  FrenchLanguageLabel: string;

  altLanguageLabel: string;
  linkList: Array<{ label: string; href: string }>;
  isMediaExtraSmall: boolean;

  private readonly _pdfSourceKey: string;

  constructor(private readonly _sessionState: SessionStorageService) {
    this.evaluateMediaWidth();

    const pdfSourceKeyMap = {
      total: {
        [Constants.LanguageCodeEnglish]: 'total',
        [Constants.LanguageCodeFrench]: 'complet'
      },
      systems: {
        [Constants.LanguageCodeEnglish]: 'systems',
        [Constants.LanguageCodeFrench]: 'systemes'
      },
      appliances: {
        [Constants.LanguageCodeEnglish]: 'appliances',
        [Constants.LanguageCodeFrench]: 'appareilsem'
      }
    };

    const languageCode = this._sessionState.getCurrentLanguageCode();
    if (this._sessionState.isProductPlanTotal()) {
      this._pdfSourceKey = pdfSourceKeyMap.total[languageCode];
    } else if (this._sessionState.isProductPlanSystems()) {
      this._pdfSourceKey = pdfSourceKeyMap.systems[languageCode];
    } else if (this._sessionState.isProductPlanAppliances()) {
      this._pdfSourceKey = pdfSourceKeyMap.appliances[languageCode];
    } else {
      this._pdfSourceKey = '';
    }
  }

  ngOnInit(): void {
    const altLanguageCode = this._sessionState.getAltLanguageCode();
    if (altLanguageCode === Constants.LanguageCodeEnglish) {
      this.altLanguageLabel = this.EnglishLanguageLabel;
    } else if (altLanguageCode === Constants.LanguageCodeFrench) {
      this.altLanguageLabel = this.FrenchLanguageLabel;
    } else {
      throw new Error(`Unhandled case - ${altLanguageCode}`);
    }

    this.linkList = [
      { label: this.PrivacyPolicyLabel, href: '/dash/privacy' },
      {
        label: this.TermsAndConditionsLabel,
        href: this._pdfSourceKey.length > 0 ? `/dash/conditions/${this._pdfSourceKey}` : ''
      },
      { label: this.FaqLabel, href: '/dash/faqs' },
      { label: this.ContactUsLabel, href: '/dash/contact' }
    ];
  }

  toggleLanguage(): void {
    event.preventDefault();

    this._sessionState.toggleCurrentLanguageCode();
  }

  @HostListener('window:resize')
  private evaluateMediaWidth(): void {
    this.isMediaExtraSmall = window.innerWidth < 576;
  }
}



// WEBPACK FOOTER //
// ./src/app/global/footer-dash.component.ts